export default __webpack_public_path__ + "static/media/board.min.ca7389e4.png";